<template>
  <div v-if="this.invoice" class="container">
    <br>
    <h5 class="row justify-content-center">
            <span style="margin-right: 15px" class="float-left">Акт <a
                :href="'https://admin.' + this.portalUrl[this.invoice.country_id] + '/payment-documents-pack/view?id=' + this.invoice.external_id"
                target="_blank" rel="noopener">{{
                this.invoice.number ? this.invoice.number : this.invoice.external_id
              }} </a></span>
      <div v-if="!isRefreshDisabled"
           @click="refreshInvoice"
           class="cursor-pointer fas fa-sync-alt float-left"
           style="margin-top: 3px; font-size: 16px"
      ></div>
      <div v-if="isRefreshDisabled">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      </div>
    </h5>
    <span v-if="message" class="float-center text-danger" style="margin-top: 8px; margin-left: 6px">
      <strong>{{ message }}</strong>
    </span>
    <br>
    <nav class="nav">
      <a @click="selectedComponent = 'appInfo'" class="nav-link cursor-pointer"
         :class="{selected: selectedComponent === 'appInfo'}">Акт</a>
      <a @click="selectedComponent = 'appTasks'" class="nav-link cursor-pointer"
         :class="{selected: selectedComponent === 'appTasks'}">Задания</a>
      <a @click="selectedComponent = 'appVersions'" class="nav-link cursor-pointer"
         :class="{selected: selectedComponent === 'appVersions'}">Версии</a>
      <a @click="selectedComponent = 'appArrearsLog'" class="nav-link cursor-pointer"
         :class="{selected: selectedComponent === 'appArrearsLog'}">Оплата</a>

    </nav>
    <br>
    <component :is="selectedComponent"></component>
    <br>
  </div>
</template>

<script>
import Vue from 'vue'
import Info from "./tabs/Info.vue"
import Tasks from "./tabs/Tasks.vue"
import Versions from "./tabs/Versions.vue"
import ArrearsLog from "./tabs/ArrearsLog.vue"
import axios from 'axios'

export default Vue.extend({
  name: 'Invoice',

  components: {
    appInfo: Info,
    appTasks: Tasks,
    appVersions: Versions,
    appArrearsLog: ArrearsLog,
  },

  data() {
    return {
      selectedComponent: "appInfo",
      message: "",
      refreshDisabled: false,
      invoice: null,
      portalUrl: {
        "ru": "wowworks.ru",
        "by": "wowworks.by",
        "de": "de.wowworks.org",
      },
    };
  },

  computed: {
    isRefreshDisabled() {
      return this.refreshDisabled
    },
  },

  methods: {
    refreshInvoice() {
      this.refreshDisabled = true;

      this.$store.dispatch('setCurrentDocId', this.$route.params.doc_id);

      axios.get(`/docs/update_from_ww/${this.$route.params.doc_id}`, {
        params: {
          country_id: this.$route.params.countryID,
        },
      })
          .then((response) => {
            this.message = "";
          })
          .catch((error) => {
            this.message = error.response.data;
            console.log(error);
          })
          .finally(() => {
            this.refreshDisabled = false;
          });
    },

    loadInvoice() {
      axios.get(`/doc_by_id`, {
        params: {
          invoice_id: this.$store.state.currentDocId,
          country_id: this.$route.params.countryID,
        },
      })
          .then((res) => {
            console.log(res.data);

            res.data.doc_date = new Date(res.data.doc_date);
            res.data.date_of_completion = new Date(res.data.date_of_completion);
            res.data.due_date = new Date(res.data.due_date);
            res.data.service_period_start = new Date(res.data.service_period_start);
            res.data.service_period_end = new Date(res.data.service_period_end);

            res.data.contract.link = 'https://admin.' + this.portalUrl[res.data.country_id] + '/contract/view?id=' + res.data.contract.external_id;
            res.data.customer.link = 'https://admin.' + this.portalUrl[res.data.country_id] + '/organization/view?id=' + res.data.customer.external_id;

            console.log(res.data);

            this.message = "";
            this.invoice = res.data;

          })
          .catch(error => console.log(error))
    },

  },


  beforeCreate() {

  },

  created() {
    this.$store.dispatch("setCurrentDocId",
        this.$route.params.doc_id
    )
        .then(() => {
          this.loadInvoice();
        });

  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
